<template>
  <!-- Booking History Display -->
  <div
    v-if="$store.getters.GET_ACTIVE_ADDRESS && isCompactDisplay"
    class="upcoming-collection-summary d-block mb-5"
  >
    <div class="row justify-content-center">
      <h6 data-v-11406f91="" class="mb-2 text-center">
        <span
          style="
            color: #76838f;
            font-family: 'Nunito Sans', sans-serif;
            font-size: 1.25rem;
            color: #3b3b3b;
          "
          v-html="TEXTS.render('UPCOMING_COLLECTION_SUMMARY_HEADER')"
        />
      </h6>
    </div>

    <div class="row">
      <div class="col-lg-4"></div>
      <div class="col-lg-4" v-if="!loadingCollectionDisplayList">
        <div
          v-if="
            Array.isArray(collectionDisplayList) &&
            collectionDisplayList.length > 0
          "
          class="collection-summary-list d-block"
        >
          <div
            class="collection-schedule"
            v-for="collectionDisplay in collectionDisplayList"
            :key="collectionDisplay.id"
          >
            <div class="col-2 pl-0">
              <img
                :src="pubPathReal + collectionDisplay.imgSrc"
                class="collection-schedule-icon"
                v-error-img-load
              />
            </div>
            <div class="col-8 pt-3">
              <span v-html="collectionDisplay.dateString" />
            </div>
          </div>
        </div>
        <h6 v-else class="font-weight-bold text-center mt-4" v-html="TEXTS.render(`UPCOMING_COLLECTION_SUMMARY_NONE`)" />
      </div>
      <div class="col-lg-4" v-else v-html="'...'" />
    </div>
  </div>

  <!-- Booking Form Display Summary -->
  <div v-else-if="!isCompactDisplay" class="row d-block ml-3 mr-3 mt-3 mb-5">
    <h6 data-v-11406f91="" class="mb-2 font-weight-bold">
      <span
        style="font-family: 'Nunito Sans', sans-serif"
        v-html="TEXTS.render('UPCOMING_COLLECTION_SUMMARY_HEADER')"
      />
    </h6>

    <div class="row ml-1 mr-1">
      <div v-if="!loadingCollectionDisplayList" class="col-lg-12 border-bottom">
        <div
          class="collection-schedule-box pt-1 pb-1 pl-4 row"
          v-for="collectionDisplay in collectionDisplayList"
          :key="collectionDisplay.id"
        >
          <div class="col-4">
            <img
              :src="pubPathReal + collectionDisplay.imgSrc"
              class="height-50px"
              v-error-img-load
            />
          </div>
          <div class="col-8 pt-3">
            <span v-html="collectionDisplay.dateString" class="ml-4" />
          </div>
        </div>
        <h6
          v-if="
            Array.isArray(collectionDisplayList) &&
            collectionDisplayList.length == 0
          "
          class="font-weight-bold text-center mt-4"
          v-html="TEXTS.render(`UPCOMING_COLLECTION_SUMMARY_NONE`)"
        />
      </div>
      <div v-else v-html="'...'" />
    </div>
  </div>
</template>

<script>
import Texts from "../../../../common/utils/Texts";
import DateNoTz from "../../../../common/utils/DateNoTz";
import RetryWorker from "../../../../common/utils/RetryWorker";

export default {
  data() {
    return {
      binTypeSettings: null,
      nextCollectionScheduleArr: null,
      collectionDisplayList: [],
      loadingCollectionDisplayList: false,
      pubPath: process.env.MIX_APP_URL,
    };
  },
  computed: {
    TEXTS: () => Texts,
    pubPathReal() {
      return this.pubPath.indexOf("storage") === -1
        ? `${this.pubPath}/storage/`
        : this.pubPath;
    },
  },
  props: {
    addressId: String,
    isCompactDisplay: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    this.$store.dispatch("getBinType").then((data) => {
      this.binTypeSettings = data.list;
    });
    if (this.addressId) {
      var self = this;
      setTimeout(() => {
        this.loadCollectionSchedule(this.addressId);
      }, 3000);
    }
  },
  methods: {
    loadCollectionSchedule(addressId) {
      var self = this;
      self.loadingCollectionDisplayList = true;
      new RetryWorker(
        5,
        200,
        function () {
          return new Promise((resolve, reject) => {
            self.$store
              .dispatch("getAddressCollectionWeek", addressId)
              .then((data) => {
                if (!data) {
                  resolve(false);
                } else {
                  self.nextCollectionScheduleArr = data
                    ? data.nextCollectionDates
                    : [];
                  self.loadingCollectionDisplayList = false;
                  resolve(true);
                }
              })
              .catch((error) => {
                resolve(false);
              });
          });
        },
        null,
        function () {
          self.nextCollectionScheduleArr = []
          self.loadingCollectionDisplayList = false;
        }
      ).doWork();
    },
  },
  watch: {
    addressId(newValue) {
      this.loadCollectionSchedule(newValue);
    },
    nextCollectionScheduleArr(newValue) {
      var collectionDisplayList = [];

      if (Array.isArray(newValue)) {
        var hash = {};
        for (let i = 0; i < newValue.length; i++) {
          const collectionSchedule = newValue[i];
          if (
            !collectionSchedule.binSize ||
            collectionSchedule.binSize.trim() == ""
          ) {
            continue;
          }

          var nextCollectionDate = new DateNoTz(
            collectionSchedule.nextCollectionDate
          );
          var searchWasteStream = collectionSchedule.wasteStream;
          var hashEntry = hash[searchWasteStream];
          if (
            !hashEntry ||
            !hashEntry.nextCollectionDate ||
            hashEntry.nextCollectionDate.convertToSeconds() >
              nextCollectionDate.convertToSeconds()
          ) {
            hash[collectionSchedule.wasteStream] = {
              dayOfTheWeek: collectionSchedule.dayOfTheWeek,
              nextCollectionDate,
            };
          }
        }
        for (const wasteStream in hash) {
          if (Object.hasOwnProperty.call(hash, wasteStream)) {
            const element = hash[wasteStream];
            collectionDisplayList.push({
              wasteStream: wasteStream,
              ...element,
            });
          }
        }
      }

      // --- Apply DisplayNames and image paths
      collectionDisplayList.forEach((collectionDisplay) => {
        var binTypeSetting = this.binTypeSettings.find((binTypeSetting) => {
          return (
            binTypeSetting.api_value.toLowerCase() ==
            collectionDisplay.wasteStream.toLowerCase()
          );
        });
        if (binTypeSetting) {
          collectionDisplay.imgSrc = binTypeSetting.icon;
          collectionDisplay.name = binTypeSetting.name;
        }
        collectionDisplay.edited = true;
        collectionDisplay.dateString = collectionDisplay.nextCollectionDate.formatDayDdMonYyyy();
      });

      this.collectionDisplayList = collectionDisplayList;
    },
  },
};
</script>

<style lang="scss" scoped>
.height-50px {
  height: 50px;
  width: auto;
}
.collection-schedule-box {
  background-color: white;
  border: 1px solid #dee2e6;
  border-bottom: none;
}

.border-bottom {
  border: 1px solid #dee2e6;
  border-top: none;
  border-left: none;
  border-right: none;
}
</style>